import {
    CardBody,
    CasesNumber,
    CasesOverview,
    CasesStatus,
    Flex,
    SmallCard,
    Title,
    TotalNumber,
} from '../StatisticsPage'
import { useTranslation } from '../../../../../hooks'

interface TotalCasesData {
    all: number
    active: number
    closed: number
}

interface TotalCasesProps {
    totalCases: TotalCasesData
}

const TotalCases = ({ totalCases }: TotalCasesProps) => {
    const translation = useTranslation()
    return (
        <SmallCard>
            <Title>{translation.header.cases}</Title>
            <CardBody>
                <TotalNumber>{totalCases.all}</TotalNumber>
                <CasesOverview>
                    <Flex alignItems="center" justifyContent="space-between">
                        <CasesStatus>
                            {
                                translation.dashboardPartner.yourStatistics
                                    .activeCases
                            }
                        </CasesStatus>
                        <CasesNumber>{totalCases.active}</CasesNumber>
                    </Flex>
                    <Flex alignItems="center" justifyContent="space-between">
                        <CasesStatus>
                            {
                                translation.dashboardPartner.yourStatistics
                                    .closedCases
                            }
                        </CasesStatus>
                        <CasesNumber>{totalCases.closed}</CasesNumber>
                    </Flex>
                </CasesOverview>
            </CardBody>
            {/* <Block>
                <UpOrDown color="green">
                    <ArrowUp color="green" />
                    21% {translation.statisticsPage.lastYear}
                </UpOrDown>
            </Block> */}
        </SmallCard>
    )
}

export default TotalCases
